import { getAPI, postAPI, putAPI } from "../..";
import config from "../../../utils/config";
import {
  ADD_PACKAGE_URL,
  APPROVE_PACKAGES_URL,
  DELETE_PACKAGES_URL,
  GET_PACKAGES_LISTING_URL,
  UPLOAD_PACKAGE_URL,
  VENDOR_DELETE_EXPENSE,
  VENDOR_EVENT_LIST,
  VENDOR_EXPENSE_LISTING,
} from "../../url";

export const getVendorEventsAPI = async (
  page_no = 1,
  per_page = 10,
  type,
  status
) => {
  let response = await getAPI(
    config.quicklinkUrl +
      VENDOR_EVENT_LIST +
      type +
      `&page=${page_no}&per_page=${per_page}&event_status=${status}`
  );
  return response;
};

export const getPackagesAPI = async (
  page_no = 1,
  per_page = 10,
  status,
  agency_name
) => {
  if (agency_name) {
    let response = await getAPI(
      config.quicklinkUrl +
        GET_PACKAGES_LISTING_URL +
        `?page=${page_no}&per_page=${per_page}&status=${status}&agency_name=${agency_name}`
    );
    return response;
  } else {
    let response = await getAPI(
      config.quicklinkUrl +
        GET_PACKAGES_LISTING_URL +
        `?page=${page_no}&per_page=${per_page}&status=${status}`
    );
    return response;
  }
};

export const addPackagesAPI = async (body) => {
  let response = await postAPI(config.quicklinkUrl + ADD_PACKAGE_URL, body);
  return response;
};

export const updatePackagesAPI = async (package_id, body) => {
  let response = await putAPI(
    config.quicklinkUrl + UPLOAD_PACKAGE_URL + package_id,
    body
  );
  return response;
};

export const approvePackagesAPI = async (body) => {
  let response = await putAPI(config.quicklinkUrl + APPROVE_PACKAGES_URL, body);
  return response;
};

export const deletePackagesAPI = async (body) => {
  let response = await postAPI(config.quicklinkUrl + DELETE_PACKAGES_URL, body);
  return response;
};

export const getExpenseListingAPI = async (activeTab, year) => {
  let response;
  if (year)
    response = await getAPI(
      config.quicklinkUrl +
        VENDOR_EXPENSE_LISTING +
        "?type=" +
        activeTab +
        "&year=" +
        year
    );
  else
    response = await getAPI(
      config.quicklinkUrl + VENDOR_EXPENSE_LISTING + "?type=" + activeTab
    );
  return response;
};

export const deleteExpenseAPI = async (id) => {
  let response = await postAPI(
    config.quicklinkUrl + VENDOR_DELETE_EXPENSE + "?media_id=" + id
  );
  return response;
};
